import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';
import Row from './Row';

const Rows = ({ severity, rowsData } = {}) =>
  rowsData?.map(rowData => <Row key={uuid()} rowData={rowData} severity={severity} />);

Rows.propTypes = {
  severity: PropTypes.string,
  rowsData: PropTypes.array
};

export default Rows;
